export const validateCPF = (cpf) => {
  if (!cpf) {
    return false;
  }

  const cleanCPF = cpf.replace(/[^\d]/g, '');
  if (cleanCPF.length !== 11) {
    return false;
  }

  if (/^(\d)\1{10}$/.test(cleanCPF)) {
    return false;
  }

  try {
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
    }

    let remainder = 11 - (sum % 11);
    if (remainder === 10 || remainder === 11) remainder = 0;

    if (remainder !== parseInt(cleanCPF.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
    }

    remainder = 11 - (sum % 11);
    if (remainder === 10 || remainder === 11) remainder = 0;

    if (remainder !== parseInt(cleanCPF.charAt(10))) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};

export const validateCPFComplete = (cpf) => {
  if (!cpf) {
    return true;
  }

  const trimmedCPF = cpf.trim();
  if (!trimmedCPF) {
    return true;
  }

  return validateCPF(trimmedCPF);
};

export const validatePassport = (passport) => {
  if (!passport) {
    return false;
  }

  const cleanPassport = passport.replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z0-9]+$/.test(cleanPassport)) {
    return false;
  }

  const length = cleanPassport.length;
  if (length < 6 || length > 9) {
    return false;
  }

  const uniqueChars = new Set(cleanPassport);
  if (uniqueChars.size === 1) {
    return false;
  }

  if (isAscendingSequential(cleanPassport)) {
    return false;
  }

  return !isDescendingSequential(cleanPassport);
};

function isAscendingSequential(passport) {
  for (let i = 1; i < passport.length; i++) {
    if (passport.charCodeAt(i) !== passport.charCodeAt(i - 1) + 1) {
      return false;
    }
  }

  return true;
};

function isDescendingSequential(passport) {
  for (let i = 1; i < passport.length; i++) {
    if (passport.charCodeAt(i) !== passport.charCodeAt(i - 1) - 1) {
      return false;
    }
  }

  return true;
};

export const INITIAL_VALUES = {
  nationality: false,
  name: "",
  last_name: "",
  assignment: "",
  credential_name: "",
  email: "",
  document: "",
  telephone: "",
  credentialType: "",
  country: undefined,
  internationalCity: "",
  state: undefined,
  brazilianCity: undefined,
};

export const validation = (
  key,
  intl,
  nationality = false,
  isFromClientView = false,
  isServiceProvider = false,
) => {
  switch (key) {
    case "nationality":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];
    case "name":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "last_name":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "assignment":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "credential_name":
    return [
      {
        required: true,
        message: intl.formatMessage({ id: "error.field_required" }),
      },
      {
        max: 23,
        message: intl.formatMessage({ id: "error.credential_max_length" }),
      },
    ];

    case "email":
    return [
      {
        required: !isServiceProvider,
        message: intl.formatMessage({ id: "error.field_required" }),
      },
      {
        type: 'email',
        message: intl.formatMessage({ id: "error.valid_email" }),
      }
    ];

    case "document":
    return [
      {
        required: true,
        message: intl.formatMessage({ id: "error.field_required" }),
      },
      {
        validator: (_, value) => {
          return new Promise((resolve, reject) => {
            if (!value) {
              resolve();
              return;
            }

            if (nationality === false) {
              const isValid = validateCPF(value);

              if (isValid) {
                resolve();
              } else {
                reject(
                  new Error(
                    intl.formatMessage({ id: "error.document_invalid_cpf" })
                  )
                );
              }
            }

            else if (nationality === true) {
              if (validatePassport(value)) {
                resolve();
              } else {
                reject(
                  new Error(
                    intl.formatMessage({ id: "error.document_invalid_passport" })
                  )
                );
              }
            } else {
              resolve();
            }
          });
        },
      },
    ];

    case "country":
      return [
        {
          required: nationality,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "internationalCity":
      return [
        {
          required: nationality,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "state":
      return [
        {
          required: !nationality,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "brazilianCity":
      return [
        {
          required: !nationality,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "telephone":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "ddi":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    case "credentialType":
      return [
        {
          required: true,
          message: intl.formatMessage({ id: "error.field_required" }),
        },
      ];

    default:
      return [];
  }
};
